import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { checkEnterprisePrivilege, hasCurrentProfileAnyServicePrivileges } from '@mews-commander/legacy-entities';
import { BookableService } from '@mews-commander/modules/src/modules/services';
import { MewsTeam, RouteType } from '@mews/enums';
import { useUUID } from '@mews/framework';

const Component = () => {
    const guideLink = createGuideLink(ArticlePath.BookableService);
    const { OwnerId: enterpriseId } = Route.useSearch();
    const id = useUUID();
    const form = `new-bookable-service-form-${id}`;

    return <BookableService enterpriseId={enterpriseId} form={form} guideLink={guideLink} />;
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Visit/Create')({
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
    }),
    beforeLoad: ({ context: { getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState }, search }) => {
        const { OwnerId: enterpriseId } = search;
        const check =
            checkEnterprisePrivilege(getState(), { enterpriseId }) === true &&
            hasCurrentProfileAnyServicePrivileges(getState());
        if (!check) {
            throw notFound();
        }
    },
    component: Component,
    staticData: {
        title: TextKey.BookableService,
        routeName: RouteName.VisitCreate,
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
    },
});
